import React, { PropsWithChildren, useState, HTMLAttributes, useEffect } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import classnames from 'classnames';
import './expansionPanel.scss';

type CollapseProps = {
    children: React.ReactNode;
    expanded?: boolean;
    onChangeExpanded?: () => void;
    theme?: 'light' | 'dark';
};

export function ExpansionPanel({
    children,
    expanded,
    className,
    onChangeExpanded,
    theme = 'light'
}: CollapseProps & HTMLAttributes<HTMLDivElement>): React.ReactElement {
    const [open, setOpen] = useState<boolean>(false);
    const [overflow, setOverflow] = useState<boolean>(false);

    const expansionPanelClass = classnames(className, theme, 'expansion-panel');
    const expansionPanelOpen = open ? 'panel-open' : 'panel-closed';
    useEffect(() => {
        setOpen(expanded);
    }, [expanded !== undefined && expanded !== open]);

    useEffect(() => {
        if (open) {
            setTimeout(function() {
                setOverflow(true);
            }, 300);
        }
        setOverflow(false);
    }, [open]);

    return (
        <div className={expansionPanelClass}>
            {React.cloneElement(children[0], {
                clickHandler: () => {
                    setOpen(!open);
                    onChangeExpanded && onChangeExpanded();
                },
                open: open,
            })}
            <div className={overflow ? `${expansionPanelOpen} overflow` : expansionPanelOpen}>
                <div className="panel-content">{children[1]}</div>
            </div>
        </div>
    );
}

type CollapseTitleProps = {
    clickHandler?: () => void;
    open?: boolean;
    theme?: 'light' | 'dark';

};

export const ExpansionPanelTitle = ({
                                        theme = 'light',
                                        ...props
                                    }: PropsWithChildren<CollapseTitleProps> & HTMLAttributes<HTMLButtonElement>
): React.ReactElement => {
    const titleClass = classnames(props.className, theme, 'expansion-panel-title');
    const handler = (event): void => {
        event.preventDefault();
        props.clickHandler();
    };

    return (
        <button className={titleClass} onClick={handler} aria-expanded={props.open}>
            <span>{props.children}</span>
            <span className={props.open ? 'icon expanded' : 'icon'}>
                <ExpandMoreIcon fontSize="large" />
            </span>
        </button>
    );
};

export const ExpansionPanelContent = (props: PropsWithChildren<{}>): React.ReactElement => {
    return <>{props.children}</>;
};